<template>
  <div class="rule-container">
    <div class="close" @click="bindClose"
      ><span class="iconfont icon-cha"></span
    ></div>
    <div class="rule-title">活动规则</div>
    <div class="rule-flex">
      <div class="rule-scroll">
        <div class="rule-list">
          <div class="rule-item" v-for="(item, index) in rules" :key="index">
            <div class="item-title">{{ item.title }}</div>
            <div class="item-li">
              <div
                class="item-li-item"
                v-for="(item1, index1) in item.list"
                :key="index1"
              >
                <div class="item-index">{{ (index1 + 1) | filterNum }}.</div>
                <div class="item-text">{{ item1 }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="btn" @click="bindClose">确定</div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: [Array, null],
      default: null
    }
  },
  components: {},
  data() {
    return {
      rules: [
        {
          title: '一、活动参与规则',
          list: [
            '活动时间：2024年12 月 24 日 9 点至2025年 1 月6 日 24 点。',
            '健萌会员活动规则：活动期间，健萌会员为自己心目中的最用心教练送出线上小红花，即视为参与活动。',
            '非健萌会员活动规则：活动期间，非健萌会员用户，点赞APP内带#被健萌治愈的瞬间 话题的任意活动贴即视为参与活动。',
            '最用心教练评选结果公布时间：2025年1月8号公布。'
          ]
        },
        {
          title: '二、小红花说明',
          list: [
            '健萌在籍会员下载并注册登录betterWE星球APP，即有两朵小红花。',
            '活动参与者首次发帖，并带话题#被健萌治愈的瞬间，关联指定教练，即可获得一朵小红花；发帖被精选后，该参与者可再次获得一朵小红花。',
            '活动期间，在小红书发布带#被健萌治愈的瞬间 话题的活动贴，截图并发送教练确认后可获得一朵小红花。',
            '仅健萌在籍会员和2024年上过课的会员可获得小红花。'
          ]
        },
        {
          title: '三、抽奖规则',
          list: [
            '每送出一朵小红花即可获得随机奖品。',
            '所有用户在活动页面进行抽奖，奖品随机抽取，100%中奖。奖品包含betterWE营养服务199元年卡、轻量健身包、体脂秤、元气红豆蛋白饮、膳食纤维、健萌周边、经验值等。',
            '抽奖时间：2024年12 月 24 日 9 点至2025年 1 月6 日 22 点。逾期之后未使用的抽奖机会将作废。'
          ]
        },
        {
          title: '四、奖品领取与发放',
          list: [
            '实物奖品需会员前往会籍门店，凭中奖记录截图领取；',
            '领奖日期：2025年1月8日 - 25日。',
            '经验值通过后台直接发送到会员账户内，实时发放到账；',
            '虚拟奖品活动结束后五个工作日内发送至参与活动的手机号对应账户内；',
            '健萌线下体验课可在健萌所有门店使用，仅限非健萌用户使用。',
            '若当前城市无健萌门店，或不满足领取条件的用户，可免费兑换成3日营养服务。',
            '中奖用户联系客服领取，有效期至2025年2月28日。'
          ]
        },
        {
          title: '五、活动监督与违规处理',
          list: [
            '为了确保活动的公平性，严禁数据造假等舞弊行为，主办方会对活动进行监督。严禁利用任何不正当手段扰乱活动秩序。异常的数据增长均被视为违规。一经查实违规行为将扣除存疑数据并追回奖品。',
            '本次活动规则的最终解释权归健萌健身所有。'
          ]
        }
      ]
    }
  },
  filters: {
    filterNum(num) {
      return num <= 9 ? '0' + num : num
    }
  },
  watch: {},
  created() {},
  methods: {
    bindSendFlower() {},
    bindClose() {
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss" scoped>
.rule-container {
  position: relative;
  height: 86vh;
  background: #ffffff;
  border-radius: 8px 8px 0px 0px;
  padding: 20px 20px 50px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  .rule-title {
    font-weight: bold;
    font-size: 18px;
    color: #050b27;
    line-height: 25px;
    margin-bottom: 18px;
  }
  .rule-flex {
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
  }
  .rule-scroll {
    height: 100%;
    overflow-y: scroll;
    .rule-list {
      padding: 10px 0px 50px;
      .rule-item {
        .item-title {
          font-weight: bold;
          font-size: 16px;
          color: #050b27;
          line-height: 22px;
          margin-bottom: 10px;
        }
        .item-li {
          .item-li-item {
            display: flex;
            align-items: flex-start;
            margin-bottom: 10px;
            .item-index {
              width: 20px;
              margin-right: 4px;
              font-size: 13px;
              color: rgba(5, 11, 39, 0.5);
              line-height: 20px;
            }
            .item-text {
              flex: 1;
              flex-shrink: 0;
              overflow: hidden;
              font-size: 13px;
              color: rgba(5, 11, 39, 0.5);
              line-height: 21px;
            }
          }
        }
      }
      .rule-item:last-child {
        margin-bottom: 0;
      }
    }
  }
  .btn {
    height: 44px;
    background: #ff2270;
    border-radius: 24px;
    font-weight: bold;
    font-size: 16px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
  }
  .close {
    position: absolute;
    right: 15px;
    top: 15px;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    .iconfont {
      font-weight: bold;
      font-size: 20px;
      color: rgba(48, 48, 56, 1);
    }
  }
}
</style>
